<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HvwcmS/tc-custom/9781504061742.jpg?1705777970358" alt="This image is the cover for the book Railway Children"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Railway Children
      </h1>
      <p class="bookDescription body article font2">
        <b>This classic—adapted for radio, television, stage, and screen—“</b><b>has a special and enduring place in British children’s literature” (<i>The Guardian</i>).</b><br/>  <br/> Roberta, Peter, and Phyllis used to live in London. But their father, who worked at the Foreign Office, was accused of spying—and now he’s in prison. So they’ve moved with their mother to the Yorkshire countryside, to a house near the railway called the Three Chimneys.<br/>  <br/> They may have much less money than they did before, but the siblings still have a great deal of adventures, and soon they make plenty of new friends: the “Old Gentleman,” who takes the 9:15 train, plus the station porter, the stationmaster, an engineer, a fireman, and a mysterious Russian man who steps off the tracks with a remarkable story to tell.<br/>  <br/> Before long, the Old Gentleman will do something very special to help his young chums—and the children will have their own chance to be heroes as well . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        E. Nesbit
      </h2>
      
      <p class="authorDescription body article">E. Nesbit (1858&ndash;1924) began writing for young adults after a successful career in magazines. Using her own unconventional childhood as a jumping-off point, she published novels that combined reality, fantasy, and humor. Expanded from a series of articles in the <I>Strand Magazine</I>, <I>Five Children and It </I>was published as a novel in 1902 and is the first in a trilogy that includes <I>The Phoenix and the Carpet </I>and <I>The Story of the Amulet</I>. Together with her husband, Nesbit was a founding member of the socialist Fabian Society, and her home became a hub for some of the greatest authors and thinkers of the time, including George Bernard Shaw and H. G. Wells.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?22b42904